import { store } from '@/store';
import { CommonConstants } from '@/constants/common';

let loadingCount = 0;
let timeoutId = null;

const loading = {
  show: () => {
    loadingCount++;
    if (loadingCount === 1) {
      timeoutId = setTimeout(() => {
        store.dispatch('common/setLoading', true);
      }, CommonConstants.LOADING_TIME);
    }
    return timeoutId;
  },
  clear: () => {
    loadingCount = Math.max(loadingCount - 1, 0);
    if (loadingCount === 0) {
      store.dispatch('common/setLoading', false);
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  },
  reset: () => {
    loadingCount = 0;
    store.dispatch('common/setLoading', false);
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }
};

export default loading;